// import external modules
import React, { Component } from "react";
import { connect } from "react-redux";
import { ComonIcons } from "../contents/commonIcons";
class Capsual extends Component {
  render() {
    //console.log("In Capsual ", this.props)
    return (
      <div className="capsual" title={this.props.title}>
        <p className={`mb-0 f-500 capsual-p ${this.props.titlestyle}`}>
        {this.props.icon && (
            <img
              src={this.props.icon}
              alt={`${this.props.title} icon`}
              className="capsual-icon"
              style={{ width: "16px", height: "16px", marginRight: "8px" }}
            />
          )}{""}
          {this.props.title}{""}
        
          {this.props.delete && (
            <span
              style={{ cursor: "pointer" }}
              className="font-weight-bold capsual-delete capsual-min-delete"
              onClick={() => this.props.deleteItem(this.props.title)}
            >
              <svg
                width="13"
                height="13"
                viewBox="0 0 13 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 2.1118L10.8882 1L6.49998 5.38822L2.1118 1L1 2.1118L5.38822 6.49998L1 10.8882L2.1118 12L6.49998 7.61178L10.8882 12L12 10.8882L7.61178 6.49998L12 2.1118Z"
                  fill="#DE0418"
                  stroke="#DE0418"
                />
              </svg>
            </span>
          )}
        </p>
      </div>
    );
  }
}

Capsual.defaultProps = {
  delete: false,
  deleteItem: () => {
    //console.log("Here")
  },
};
const mapStateToProps = (state) => {
  return {};
};
export default connect(mapStateToProps, {})(Capsual);
